import React from "react";
import { Accordion, AccordionProps, SxProps, Theme } from "@mui/material";

export type WcAccordionProps = AccordionProps & {
  
  sx?: SxProps<Theme>;
 
}

export const WcAccordion = (props: WcAccordionProps) => (
  <Accordion sx={props.sx} {...props} />
);

export default WcAccordion;
